module.exports = __webpack_public_path__ + "img/quote-craig-myers.19cabf32.png";